import { Space, Tabs } from "antd";

function SettingsPageV2() {
  return (
    <Space direction={"vertical"}>
      <Tabs defaultActiveKey="categories">
        <Tabs.TabPane tab="Categories" key="categories">
          Categories
        </Tabs.TabPane>
        <Tabs.TabPane tab="Brands" key="brands">
          Brands
        </Tabs.TabPane>
        <Tabs.TabPane tab="Part types" key="partTypes">
          Part types
        </Tabs.TabPane>
        <Tabs.TabPane tab="Suppliers" key="suppliers">
          Suppliers
        </Tabs.TabPane>
        <Tabs.TabPane tab="Users" key="users">
          Users
        </Tabs.TabPane>
        <Tabs.TabPane tab="Roles" key="roles">
          Roles
        </Tabs.TabPane>
        <Tabs.TabPane tab="Permissions" key="permissions">
          Permissions
        </Tabs.TabPane>
        <Tabs.TabPane tab="Settings" key="settings">
          Settings
        </Tabs.TabPane>
      </Tabs>
    </Space>
  );
}

export default SettingsPageV2;
